/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

//aタグ スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);

    var gap = 0;

    if($(this).attr('data-scroll-gap')) {
      gap = parseInt($(this).attr('data-scroll-gap'));

      if($('.u-sp').css('display') != 'none' && $(this).attr('data-scroll-gap-sp')) {
        gap = parseInt($(this).attr('data-scroll-gap-sp'));
      }
    }

    var position = target.offset().top + gap;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    
    $('.p-hd__menu button').removeClass('is-on');
    $('.p-hd__nav').removeClass('is-show');
    
    return false;
  });
});

//スライダー
$(function(){
  $('.home-kv__slick').each(function(index, el) {
    const $slider = $(this);

    $slider.slick({
      autoplay: true,
      autoplaySpeed: 3000,
      fade: true,
      speed: 1000,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: false,
      dots: false
    });
  });
});

//フェード
$(function(){
  var fade = $('.u-fade, .js-fadeAni');

  fade.each(function(index, el) {
    var t = $(this);

    setTimeout(function(){
      $(window).on('resize scroll', function(event) {
        run();
      });

      run();
    }, 200);

    function run() {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + 50;
      var pointSc = winB;
      var pointD = 200;

      var h = t.attr('data-fade-h');
      if(h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if(sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if(d) {
        pointD = d;
      }

      if(pointH < pointSc) {
        setTimeout(function(){
          t.addClass('is-fade');
          next();
        }, pointD);
      }
    }

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if(nextStr) {
        var nextArr = nextStr.split(' ');
        if(nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if(nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 200;
              if(nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 200;
              if(nextDelay) {
                step = delay;
              }
              if(nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function(index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function(){
                  t2.addClass('is-fadeNext');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});

$(function(){
  const $menu = $('.p-hd__menu button');

  if($menu[0]) {
    const $nav = $('.p-hd__nav');

    $menu.on('click', function () {
      $menu.toggleClass('is-on');
      $nav.toggleClass('is-show');
    });
  }
});

$(function(){
  const $sec = $('.js-sec');

  if($sec[0]) {
    const $bg = $('.home-bg__sec');
    const $hd = $('.l-header');
    const $hdMenu = $('.p-hd__menu');
    const $ft = $('.l-footer');

    let now = 0;
    let old = -1;
    let dir = 0;

    let nowCenter = 0;
    let oldCenter = -1;

    $(window).on('scroll', function () {
      run();
    });
    
    run();

    function run() {
      let winT = $(window).scrollTop();
      let winH = $(window).innerHeight();
      let winW = $(window).innerWidth();
      let winB = winT + winH;
      let winC = winT + winH / 2;

      $sec.each(function (index, element) {
        const $t = $(this);
        let tT = $t.offset().top;
        let tAniCenterGap = 0;

        //mv過ぎたらロゴ消す
        if(winT > winH) {
          $hd.addClass('is-logoHide');
        } else {
          $hd.removeClass('is-logoHide');
        }

        if(winB > tT) {
          now = index;
        }

        if($t.attr('data-anicenter-gap')) {
          tAniCenterGap = parseInt($t.attr('data-anicenter-gap'));

          if($('.u-sp').css('display') != 'none' && $t.attr('data-anicenter-gap-sp')) {
            tAniCenterGap = parseInt($t.attr('data-anicenter-gap-sp'));
          }
        }

        if(winC > tT + tAniCenterGap) {
          nowCenter = index;
        }

        //メニュー色切り替え
        let hdGap = 0;
        if (winW > 991) { //PCの場合
          hdGap = 50;
          if($t.hasClass('home-sec4')) {
            hdGap = -187;
          } else if($t.hasClass('home-sec9')) {
            hdGap = -200;
          } else if($t.hasClass('home-sec10')) {
            hdGap = 145;
          } else if($t.hasClass('home-sec12')) {
            hdGap = -260;
          }
        } else { //SPの場合
          hdGap = 30;
          if($t.hasClass('home-sec10')) {
            hdGap = $('.home-sec9').innerHeight() - (winW * 1.50769230769) + 30;
          } else if($t.hasClass('home-sec13')) {
            hdGap = $('.home-sec12').innerHeight() - $('.home-sec12 .home-sec12__bg').innerHeight() + 30;
          }
        }

        if(winT + hdGap > tT) {
          if($t.attr('data-bg-white') == '1') {
            $hd.addClass('is-bgWhite');
          } else {
            $hd.removeClass('is-bgWhite');
          }
        }
        
        if(winT + 50 > $ft.offset().top) {
          $hd.removeClass('is-bgWhite');
        }
      });

      if(old != now) {
        if(!$sec.eq(old).hasClass('is-crOld')) {
          $sec.eq(old).addClass('is-crOld');
        }

        if(old < now) {
          dir = 1;
        } else {
          dir = -1;
        }

        old = now;

        if(dir == 1) {
          $bg.filter('.is-cr').addClass('is-oldTmp');
          $bg.removeClass('is-old is-cr is-next is-prev').eq(now).addClass('is-cr is-next');
          $bg.filter('.is-oldTmp').removeClass('is-oldTmp').addClass('is-old is-next');
        } else {
          $bg.filter('.is-cr').addClass('is-oldTmp');
          $bg.removeClass('is-old is-cr is-next is-prev').eq(now).addClass('is-cr is-prev');
          $bg.filter('.is-oldTmp').removeClass('is-oldTmp').addClass('is-old is-prev');
        }

        $sec.removeClass('is-cr').eq(now).addClass('is-cr');

        if(!$sec.eq(now).hasClass('is-ani')) {
          $sec.eq(now).addClass('is-ani');
        }

        // if($sec.find('.js-secMovie')[0]) {
        //   setTimeout(function(){
        //     $sec.find('.js-secMovie')[0].currentTime = 0;
        //     $sec.find('.js-secMovie')[0].play();
        //   }, 1000);
        // }

        // if($sec.find('.js-sec13Ani')[0]) {
        //   sec13Ani($sec.find('.js-sec13Ani'));
        // }
      }

      if(oldCenter != nowCenter) {
        if(!$sec.eq(oldCenter).hasClass('is-aniCenterOld')) {
          $sec.eq(oldCenter).addClass('is-aniCenterOld');
        }

        oldCenter = nowCenter;

        if(!$bg.eq(nowCenter).hasClass('is-aniCenter')) {
          $bg.removeClass('is-aniCenter').eq(nowCenter).addClass('is-aniCenter');
        }

        if(!$sec.eq(nowCenter).hasClass('is-aniCenter')) {
          $sec.eq(nowCenter).addClass('is-aniCenter');
        }

        if($sec.eq(nowCenter).find('.js-secMoviePC')[0]) {
          if(!$sec.eq(nowCenter).find('.js-secMoviePC').hasClass('is-play')) {
            setTimeout(function(){
              $sec.eq(nowCenter).find('.js-secMoviePC').addClass('is-play');
              $sec.eq(nowCenter).find('.js-secMoviePC')[0].currentTime = 0;
              $sec.eq(nowCenter).find('.js-secMoviePC')[0].play();
            }, 0);
          }
        }

        if($sec.eq(nowCenter).find('.js-secMovieSP')[0]) {
          if(!$sec.eq(nowCenter).find('.js-secMovieSP').hasClass('is-play')) {
            setTimeout(function(){
              $sec.eq(nowCenter).find('.js-secMovieSP').addClass('is-play');
              $sec.eq(nowCenter).find('.js-secMovieSP')[0].currentTime = 0;
              $sec.eq(nowCenter).find('.js-secMovieSP')[0].play();
            }, 0);
          }
        }

      }
    }

    // function sec13Ani($tar){
    //   $tar.each(function (index, element) {
    //     const $t = $(this);

    //     if(!$t.hasClass('is-ani')) {
    //       let startWait = 2000;

    //       if (window.matchMedia("(max-width: 991px)").matches) {
    //         startWait = 0;
    //       }

    //       setTimeout(function(){
    //         let sec13Now = -1;
    //         const $sec13Img = $t.find('.-img');

    //         $t.addClass('is-ani');

    //         setInterval(function(){ sec13AniNext() }, 4000);
    //         sec13AniNext();

    //         function sec13AniNext() {
    //           sec13Now ++;

    //           if(sec13Now >= $sec13Img.length) sec13Now = 0;

    //           $sec13Img.removeClass('is-cr').eq(sec13Now).addClass('is-cr is-ani');

    //           let $sec13ImgNow = $sec13Img.eq(sec13Now);

    //           setTimeout(function(){
    //             $sec13ImgNow.removeClass('is-ani');
    //           }, 6000);
    //         }
    //       }, startWait);
    //     }
    //   });
    // }
  }
});

// $(function(){
//   const $sec = $('.js-pB');

//   if($sec[0]) {
//     $(window).on('resize', function () {
//       run();
//     });

//     run();

//     function run() {
//       $sec.each(function (index, element) {
//         const $t = $(this);
//         const $inner = $t.find('.js-pBInner');

//         let pB = 0;

//         pB = $inner.innerHeight();

//         $t.css({
//           'padding-bottom': pB
//         })
//       });
//     }
//   }
// });

$(function(){
  const $el = $('.js-shift');

  if($el[0]) {
    $(window).on('scroll', function () {
      run();
    });

    run();

    function run() {
      $el.each(function (index, element) {
        const $t = $(this);
        const $inner = $t.find('.js-shiftInner');

        let tT = $t.offset().top;
        let tH = $t.innerHeight();
        let tB = tT + tH;
        let tC = tT + tH / 2;

        let winT = $(window).scrollTop();
        let winH = $(window).innerHeight();
        let winB = winT + winH;
        let winC = winT + winH / 2;

        let y = 0;

        y = (tC - winC) / 2;

        if(winB > tT && winT < tB) {
          $inner.css({
            'transform': 'translateY(' + y + 'px)'
          })
        }
      });
    }
  }
});


$(function(){
  const $el = $('.u-secAniImg');

  if($el[0]) {
    $(window).on('resize', function () {
      run();
    });

    run();

    function run() {
      $el.each(function (index, element) {
        const $t = $(this);
        const $img = $t.find('.u-secAniImg__img');

        let w = $t.innerWidth();

        $img.css({
          width: w
        });
      });
    }
  }
});



$(function(){
  const $el = $('.js-bgSc');

  if($el[0]) {
    $(window).on('scroll resize', function () { run(); });
    run();

    function run() {
      $el.each(function (index, element) {
        const $bgSec = $(this);
        let $bgImg = $bgSec.find('div');
        const dataBgAddTarget = $bgSec.attr('data-bg-add-target');

        if(dataBgAddTarget) {
          const $bgAdd = $('[data-bg-add-id=' + dataBgAddTarget + ']');

          if($bgAdd[0]) {
            $bgImg = $bgImg.add($bgAdd);
          }
        }

        if($bgSec.hasClass('is-cr')) {
          const $sec = $('.js-sec.is-cr');

          const dataSizes = $bgSec.attr('data-bg-sizes');
          const sizes = dataSizes.split(',');
          let bgRatioW = 0;

          if (window.matchMedia("(max-width: 991px)").matches) {
            bgRatioW = sizes[2] / sizes[3]; //SP
          } else {
            bgRatioW = sizes[0] / sizes[1]; //PC
          }

          const winW = $(window).innerWidth();
          const winH = $(window).innerHeight();
          const winT = $(window).scrollTop();
          const winB = winT + winH;
          const winRatioW = winW / winH;

          if(bgRatioW < winRatioW) {
            const bgW = winW;
            const bgH = bgW / bgRatioW;

            const secT = $sec.offset().top;
            const secH = $sec.innerHeight() - 200;
            const secB = secT + secH;
  
            let y = 0;
            let winBgGap = (bgH - winH) / 2;
            let winSecGap = secB - winB;

            if(winSecGap > winBgGap) {
              y = winBgGap * -1;
            } else {
              y = winSecGap * -1;

              if(y > 0) y = 0;
            }
      
            $bgImg.css({
              'background-position': 'center bottom ' + String(y) + 'px'
            });
          } else {
            $bgImg.css({
              'background-position': 'center center'
            });
          }
        }
      });
    }
  }
});

$(function(){
  // const $intro = $('.p-intro');

  // if($intro[0]) {
  //   let showDelay = 1000;
  //   let hideDelay = 1500;

  //   if(location.hash == '#skip') {
  //     $intro.hide();
  //   } else {
  //     disabledScroll();

  //     setTimeout(function(){
  //       $("html, body").scrollTop(0);
  //       $intro.addClass('is-ani');
        
  //       setTimeout(function(){
  //         $intro.addClass('is-hide');
          
  //         enabledScroll();
  //         $("html, body").scrollTop(0);
  //       }, hideDelay);
  //     }, showDelay);
  //   }

  //   function noscroll(e){
  //   }
    
  //   function disabledScroll() {
  //     lenis.stop();
  //     $('body').addClass('is-noSc');
  //   }
    
  //   function enabledScroll() {
  //     lenis.start();
  //     $('body').removeClass('is-noSc');
  //   }
  // }
});

$(function(){
  const $hd = $('.l-header');

  if($hd[0]) {
    let showDelay = 2000;

    if(location.hash == '#skip') {
      showDelay = 0;
    }

    setTimeout(function(){
      $hd.addClass('is-intro');
    }, showDelay);
  }
});

$(function(){
  const $kv = $('.home-kv');

  if($kv[0]) {
    let showDelay = 0;

    if(location.hash == '#skip') {
      showDelay = 100;
    }
    
    setTimeout(function(){
      $kv.addClass('is-intro');
    }, showDelay);
  }
});

$(function(){
  const $root = $('.u-secAniImg2');

  if($root[0]) {
    $(window).on('scroll', function () { run(); });
    run();

    function run() {
      let winT = $(window).scrollTop();
      let winH = $(window).innerHeight();
      let winB = winT + winH;

      $root.each(function (index, element) {
        const $wrap = $(this);
        const $img = $wrap.find('.u-secAniImg2__img');

        let wrapT = $wrap.offset().top;
        let wrapH = $wrap.innerHeight();
        let wrapB = wrapT + wrapH;
        
        let per = (winB - wrapT) / (winH + wrapH);

        if(per >= 0 && per <= 1) {
          let y = 500 * per;
          
          if (window.matchMedia("(max-width: 991px)").matches) {
            y = 0;
          }

          let cssY = 'translateY(' + y + 'px)';

          let cpT = 100 * (1 - per);
          let cpB = 100 * per;
          
          if (window.matchMedia("(max-width: 991px)").matches) {
            cpT = 50 * (1 - per);
            cpB = 50 * per;
          }

          let cssCP = 'inset(' + cpT + 'px 0 ' + cpB + 'px 0)';

          if($wrap.hasClass('-sec6')) {
            if(!$('.home-sec6').hasClass('is-aniCenter')) {
              $wrap.attr('data-y-gap', y);
              cssY = 'translateY(0)';
            } else {
              cssY = 'translateY(' + (y - parseInt($wrap.attr('data-y-gap'))) + 'px)';
            }
          }

          $wrap.css({
            'transform': cssY,
            'clip-path': cssCP
          });
        }
      });
    }
  }
});

$(function(){
  const $root = $('.u-secBg');

  if($root[0]) {
    $(window).on('scroll', function () { run(); });
    run();

    function run() {
      let winT = $(window).scrollTop();
      let winH = $(window).innerHeight();
      let winB = winT + winH;

      $root.each(function (index, element) {
        const $wrap = $(this);
        const $inner = $wrap.find('.u-secBg__inner');

        let wrapT = $wrap.offset().top;
        let wrapH = $wrap.innerHeight();
        let wrapB = wrapT + wrapH;
        
        let per = (winB - wrapT) / (winH + wrapH);
        let gap = winB - wrapT;

        if(per >= 0 && per <= 1) {
          let y = gap * .2;
          
          if (window.matchMedia("(max-width: 991px)").matches) {
            y = 0;
          }

          let cssY = 'translateY(' + y + 'px)';

          $inner.css({
            'transform': cssY
          });
          
          if($wrap.hasClass('-txt')) {
            cssY = 'translateY(' + (y * -1) + 'px)';
  
            $inner.css({
              'transform': cssY
            });
          }
          
          if($wrap.hasClass('-sec8')) {
            cssY = 'translateY(' + (y * 1.5) + 'px)';
  
            $inner.css({
              'transform': cssY
            });

            let cssY2 = 'calc(100% + ' + (y * 1.5) + 'px)';
            $wrap.css({
              'height': cssY2
            });

            let cssY3 = 'inset(' + (y * 1.8) + 'px 0 0 0)';

            $wrap.css({
               'clip-path': cssY3
            });
          }
          
          if($wrap.hasClass('-sec9')) {
            let cssY2 = 'calc(100% + ' + y + 'px)';
            let cssY3 = 'inset(' + (y * 1.5) + 'px 0 0 0)';
          
            // $wrap.css({
            //   'height': cssY2
            // });
            // $wrap.css({
            //    'clip-path': cssY3
            // });
          }
          
          if($wrap.hasClass('-sec12')) {
            let cssY3 = 'inset(' + (y * 1.5) + 'px 0 0 0)';
            
            $wrap.css({
               'clip-path': cssY3
            });
          }
        }
      });
    }
  }
});

$(function(){
  const $ft = $('.l-footer');

  if($ft[0]) {
    $(window).on('scroll resize', function () { run(); });
    run();

    function run() {
      const winW = $(window).innerWidth();
      const winH = $(window).innerHeight();
      const winT = $(window).scrollTop();
      const winB = winT + winH;
      
      const ftT = $ft.offset().top;
      const ftH = $ft.innerHeight() - 200;
      const ftB = ftT + ftH;
      const ftC = ftT + ftH / 2;

      if(winB > ftC) {
        $ft.addClass('is-ani');
      }
    }
  }
});